<template>
  <div>
    <loading :active="isLoading" :can-cancel="false" :is-full-page="true" />
    <v-snackbar v-model="snackbar" :top="snackbar.position === 'top'" :location="'top'" :multi-line="false"
      :timeout="6000" :vertical="false">
      {{ snackbarText }}
     
      <template v-slot:actions>
        <v-btn color="pink" variant="text" @click="snackbar = false">Close</v-btn>         
      </template>
    </v-snackbar>
    <v-card prepend-icon="mdi-cog" style="padding-right: 0px;">
      <template v-slot:title>
        <h3 class="text-black">Settings</h3>
      </template>

    </v-card>

    <!-- <v-expansion-panel v-model="expanded">
      <v-expansion-panel-content>-->
    <!-- <v-card>
        <v-card-title>
          <h3 class="black--text">Filter Options</h3>
          <v-switch
            class="swtich"
            v-model="expanded"
            v-bind:label="expanded?'on':'off'"
            v-on:change="filterChange()"
          ></v-switch>
          <span v-if="expanded==1" class="position_right">
            <v-btn small color="success" @click="saveUsers()">Save</v-btn>

          </span>
        </v-card-title>
      </v-card> -->

    <v-card>
      <v-row no-gutters>
        <v-col cols="6">
          <v-card-title>
            <h4 class="text-black">Filter Options</h4>
          </v-card-title>
        </v-col>
        <v-col cols="6">
          <v-card-actions>
            <v-container>
              <v-row no-gutters>
                <v-col cols="6" xs="4" md="6"
                  style="text-align: right; text-align: right;right: 125px; position: absolute;top: 8px; padding-right: 16px;">
                  <span v-if="expanded == 1">
                    <v-btn variant="elevated" elevation="8" rounded="xs" color="success" @click="saveUsers()">Save</v-btn>
                    <!-- <v-btn small color="error" @click="cancel()">Cancel</v-btn> -->
                  </span>
                </v-col>
                <v-col cols="6" xs="4" md="6" style="text-align: right;">
                  <v-switch color="primary" class="swtich" v-model="switchModelvalue" :model-value="switchModelvalue?true:false"  v-bind:label="switchModelvalue ? 'on' : 'off'"
                    v-on:update:model-value="filterChange()" />
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-col>
      </v-row>
    </v-card>

    <v-divider />
    <v-layout v-if="expanded == 1" row>
      <v-col col="12" style="padding-left: 0px;padding-right: 0px; padding-top: 0px;">
        <v-card>
          <v-card-title style="padding: 7px;">
            <v-row>
              <v-col cols="1" style="text-align: center;padding-right: 0px;">
                <h5 class="text-black">Users</h5>
              </v-col>
              <v-col cols="8" style="text-align: left;padding-left: 0px;">
                <v-btn @click="refreshList()" variant="text" color="green">
                  <v-icon dark>mdi-refresh</v-icon>Refresh List
                </v-btn>
                <small class="font-weight-light">Last refresh time : {{ refreshTime }}</small>
              </v-col>
            </v-row>
          </v-card-title>

          <v-text-field style="padding-top: 0px;" name="input-1-3" label="Search Users" single-line variant="underlined"
            color="primary" prepend-icon="mdi-magnify" v-model="searchText" @update:model-value="search" />
          <div style="text-align: left;">
            <v-btn color="info" size="small" variant="outlined" @click="selectAll()"
              style="margin-right: 15px;margin-left: 15px;">Select All</v-btn>
            <v-btn color="warning" size="small" variant="outlined" @click="unselectAll()">Unselect All</v-btn>

          </div>
          <v-list>
            <!-- <v-subheader>Users</v-subheader> -->
            <v-list-item v-if="searchUsers.length == 0">

              <v-list-item-title>No result found.</v-list-item-title>

            </v-list-item>
            <v-list-item v-for="user in searchUsers" :key="user.AssignedUserID" @click="user.Active = !user.Active"
              density="compact" style="height: 10px;">

              <template v-slot:prepend="{ isActive }">
                <v-list-item-action start>
                  <v-checkbox v-model="user.Active" style="padding-left: 20px !important; " />
                </v-list-item-action>
              </template>
              <v-list-item-title style="padding-bottom: 15px !important; ">
                {{ user.AssignedUserID }} - {{ user.UserDescription }}
              </v-list-item-title>

            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-layout>
    <!-- </v-expansion-panel-content>
      </v-expansion-panel>-->

  </div>
</template>
<script>
// eslint-disable-next-line
/* eslint-disable */
import DataService from '@/services/data-service';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

const dataService = new DataService();
export default {
  name: 'settings',
  data: () => ({
    snackbar: false,
    expanded: 0,
    switchModelvalue:false,
    snackbarText: '',
    searchText: '',
    searchUsers: [],
    users: [],
    isLoading: false,
    refreshTime: '',
  }),
  created() {
    this.initilize();
  },
  components: {
    Loading,
  },
  methods: {
    initilize() {
      this.refreshTime = localStorage.getItem('UserRefreshTime');
      this.isLoading = true;
      this.expanded = localStorage.getItem('enablefilter') === 'true' ? 1 : 0;
      this.switchModelvalue =localStorage.getItem('enablefilter') === 'true' ? true : false;
      dataService.GetUserPrefrences().then((response) => {
        this.users = response;
        this.isLoading = false;
        this.searchUsers = Object.assign([], this.users);
      });
    },
    cancel() {
      this.expanded = 1;
    },
    filterChange() {
      
      localStorage.setItem('enablefilter', this.switchModelvalue);
      this.expanded  =  this.switchModelvalue === true ? 1 : 0;
    },
    saveUsers() {
      const isFiltered =
        this.users.filter(user => user.Active === false).length > 0;
        localStorage.setItem("isFiltered", isFiltered);
      dataService
        .UpdateUserPrefrences(this.users)
        .then((response) => {
          this.snackbar = true;
          this.snackbarText = 'Settings saved successfully';
        })
        .catch((e) => {
          this.snackbar = true;
          this.snackbarText = 'Settings saved failed';
        });
    },
    refreshList() {
      this.isLoading = true;
      dataService
        .SetUserPrefrences()
        .then(() => {
          this.isLoading = false;
          this.initilize();
        })
        .catch((e) => {
          this.isLoading = false;
          console.log(e, 'Error SetUserPrefrences');
        });
    },
    selectAll() {
      this.searchUsers.forEach((user) => {
        user.Active = true;
      });
    },
    unselectAll() {
      this.searchUsers.forEach((user) => {
        user.Active = false;
      });
    },
    search() {
      this.searchUsers = Object.assign([], this.users);
      this.searchUsers = this.searchUsers.filter((user) => {
        const srch = this.searchText;
        return (
          user.AssignedUserID.toLowerCase().indexOf(srch.toLowerCase()) !==
          -1 ||
          user.UserDescription.toLowerCase().indexOf(srch.toLowerCase()) !== -1
        );
      });
    },
  },
};
</script>

<style>
.padding_left_20 {
  padding-left: 12px;
}

.v-list {
  height: 400px;
  overflow-y: auto;
}

.text_right {
  text-align: right;
}

.position_right {
  right: 125px !important;
  position: absolute !important;
  top: 3px !important;
}

.v-expansion-panel__header {
  background-color: white;
}

.swtich {
  position: absolute;
  top: -8px;
  right: 57px;
  z-index: 1000;
}
</style>
